import { createAsyncThunk } from '@reduxjs/toolkit'

import { cloudFunctionInstance } from 'core/config/axios'
import { service } from 'core/service/firebase'

export const createUser = createAsyncThunk(
  'users-management/createUser',
  async (
    {
      name,
      email,
      password,
      role,
      managerId,
      isActive,
      userCanCreateWFHRequest,
      employeeNo,
    }: {
      name: string
      email: string
      password: string
      role: string
      managerId: string
      isActive: boolean
      userCanCreateWFHRequest: boolean
      employeeNo: string
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await cloudFunctionInstance.post('/createUserV2', {
        name,
        email,
        password,
        role,
        managerId,
        isActive,
        userCanCreateWFHRequest,
        employeeNo,
      })
      return response
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const updateUser = createAsyncThunk(
  'users-management/updateUser',
  async (
    {
      uid,
      name,
      email,
      newPassword,
      role,
      managerId,
      isActive,
      userCanCreateWFHRequest,
      employeeNo,
    }: {
      uid: string
      name: string
      email: string
      newPassword: string
      role: string
      managerId: string
      isActive: boolean
      userCanCreateWFHRequest: boolean
      employeeNo: string
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await cloudFunctionInstance.post('/updateUserV2', {
        uid,
        name,
        email,
        newPassword,
        role,
        managerId,
        isActive,
        userCanCreateWFHRequest,
        employeeNo,
      })
      return response
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getAllUsers = createAsyncThunk(
  'users-management/getAllUsers',
  async (role: string, { rejectWithValue }) => {
    try {
      return await service.getAllUsers(role)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)
